import service from '@/store/services/devices-service';

const state = {
    list: {},
    device: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, device) => {
        state.device = device;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({commit, dispatch}, params) {
        return service.list(params)
            .then(({list, meta}) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({commit, dispatch}, params) {
        return service.get(params)
            .then((device) => {
                commit('SET_RESOURCE', device);
            });
    },

    add({commit, dispatch}, params) {
        return service.add(params)
            .then((device) => {
                commit('SET_RESOURCE', device);
            });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((device) => {
                commit('SET_RESOURCE', device);
            });
    },

    destroy({commit, dispatch}, params) {
        return service.destroy(params);
    },

    searchByPhone({commit, dispatch}, params) {
        return service.searchByPhone(params)
            .then((device) => {
                commit('SET_RESOURCE', device);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    device: state => state.device,
    meta: state => state.meta,
};

const devices = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default devices;
